/*
 * @Descripttion: 会员「剩余时长叠加」到期口径（与后端 PermissionCatalog.stackedMemberExpireAt 一致）
 *
 *   base   = (当前到期仍晚于 now) ? 当前到期 : now
 *   result = base + MEMBER_DURATION_YEARS 年 所在日的 00:00:00
 *
 * 即：已开通未到期 → 原到期 + 1 年（剩余时长完整保留）；未开通 / 已过期 → now + 1 年。
 * 本模块只做纯计算，供购买弹窗预览「购买后到期时间」，权益实际生效以后端写入为准；
 * 纯函数便于单测（tests/memberExpiry.test.js）。
 * @params:
 *   currentExpiry [String] users.express_time，形如 "yyyy-MM-dd HH:mm:ss"，可为空
 *   now           [Number|Date] 当前时刻，缺省取 Date.now()（便于测试注入）
 * @Date: 2026-10-04
 */
const MEMBER_DURATION_YEARS = 1
const DAY_MS = 24 * 60 * 60 * 1000

function pad2 (value) {
  return String(value).padStart(2, '0')
}

/** 解析后端返回的 "yyyy-MM-dd HH:mm:ss"（部分浏览器对 '-' 分隔解析不一致，统一换成 '/'） */
function parseDateTime (text) {
  const normalized = String(text === undefined || text === null ? '' : text).trim()
  if (!normalized) {
    return null
  }
  const parsed = new Date(normalized.replace(/-/g, '/'))
  return Number.isFinite(parsed.getTime()) ? parsed : null
}

function toNowDate (now) {
  if (now instanceof Date) {
    return now
  }
  if (now === undefined || now === null) {
    return new Date()
  }
  const parsed = new Date(Number(now))
  return Number.isFinite(parsed.getTime()) ? parsed : new Date()
}

/** 与 java.time.LocalDate.plusYears 口径一致：闰日（2/29）+ 1 年落到 2/28 */
function plusYears (date, years) {
  const year = date.getFullYear() + years
  const month = date.getMonth()
  const lastDayOfMonth = new Date(year, month + 1, 0).getDate()
  const day = Math.min(date.getDate(), lastDayOfMonth)
  return new Date(year, month, day)
}

/** 会员到期时间是否仍然有效（未过期） */
function isMemberActive (currentExpiry, now) {
  const current = parseDateTime(currentExpiry)
  if (!current) {
    return false
  }
  return current.getTime() > toNowDate(now).getTime()
}

/** 叠加后的到期时间（Date 对象，已归到当天 00:00:00） */
function stackedMemberExpiry (currentExpiry, now) {
  const nowDate = toNowDate(now)
  const current = parseDateTime(currentExpiry)
  const base = (current && current.getTime() > nowDate.getTime()) ? current : nowDate
  const stacked = plusYears(base, MEMBER_DURATION_YEARS)
  stacked.setHours(0, 0, 0, 0)
  return stacked
}

function formatDate (date) {
  return date.getFullYear() + '-' + pad2(date.getMonth() + 1) + '-' + pad2(date.getDate())
}

function formatDateTime (date) {
  return formatDate(date) + ' ' + pad2(date.getHours()) + ':' + pad2(date.getMinutes()) + ':' + pad2(date.getSeconds())
}

/**
 * 供购买弹窗展示的会员到期信息。
 * @returns {{active: Boolean, currentText: String, stackedText: String, remainingDays: Number}}
 */
function describeMemberExpiry (currentExpiry, now) {
  const nowDate = toNowDate(now)
  const current = parseDateTime(currentExpiry)
  const active = !!current && current.getTime() > nowDate.getTime()
  const stacked = stackedMemberExpiry(currentExpiry, now)
  return {
    active: active,
    currentText: current ? formatDate(current) : '',
    stackedText: formatDate(stacked),
    remainingDays: active ? Math.ceil((current.getTime() - nowDate.getTime()) / DAY_MS) : 0
  }
}

module.exports = {
  MEMBER_DURATION_YEARS,
  parseDateTime,
  isMemberActive,
  stackedMemberExpiry,
  describeMemberExpiry,
  formatDate,
  formatDateTime
}
